import styled from "styled-components";

export const StyledTranslationContainer = styled.div`
  #google_translate_element {
    display: initial;
    background-color: var(--lib-foreground);
    border-radius: 5px;
    margin-right: 12px;
    padding-left: 8px;
    padding-right: 8px;
    float: right;

    @media (max-width: 672px) {
      margin-right: 0;
    }
  }
`;
